module.exports = __webpack_public_path__ + "static/media/SI.0a0df029.png";